import moment from "moment";
import "moment/locale/fr";
import "moment/locale/nl";
const ExportDateFormat = "YYYY/MM/DD hh:mm A";

export const LongDateFormat = (date, lang) =>
  moment(date, ExportDateFormat).locale(lang).format("LLL");

export const ShortDateFormat = (date, lang) =>
  moment(date, ExportDateFormat).locale(lang).format("LL");

export const CardViewDateFormat = (date, lang) =>
  moment(date, "DD/MM/YYYY").locale(lang).format("DD/MM/YYYY");

export const TimeFormat = (date) =>
  moment(date, ExportDateFormat).format("h:mm A");

export const FromNow = (date, lang) =>
  moment(date, ExportDateFormat).locale(lang).fromNow();

export const RetentionDateFormat = (date, lang) =>
  moment(date, ExportDateFormat).locale(lang).format("DD/MM/YYYY");

export const getDate = (date) => moment(date).format("DD/MM/YYYY");

export const plainUKDate = (date) => moment(date, "DD/MM/YYYY");

export const longDateTime = (date, lang) => moment(date).locale(lang).format('DD/MM/YYYY HH:mm');

export const isDateString = (dateString) => {
  const reg =
    /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|(([1][26]|[2468][048]|[3579][26])00))))$/g;

  return reg.test(dateString);
};

export default {
  LongDateFormat,
  ShortDateFormat,
  TimeFormat,
  FromNow,
  getDate,
  plainUKDate,
  isDateString,
  CardViewDateFormat,
  RetentionDateFormat,
  longDateTime
};
